import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../components/button/common.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button {
  position: relative;

  display: flex;

  gap: 0.25rem;
  align-items: center;
  justify-content: center;

  width: 9rem;
  height: 2rem;

  padding-right: 0.5rem;
  padding-left: 0.5rem;

  font: var(--type-emphasis-m);
}

.progress {
  display: block;

  width: 0.8rem;
  height: 0.8rem;

  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./observatory/results/rescan-button.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;;EAElB,aAAa;;EAEb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;;EAEvB,WAAW;EACX,YAAY;;EAEZ,qBAAqB;EACrB,oBAAoB;;EAEpB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;;EAEd,aAAa;EACb,cAAc;;EAEd,kBAAkB;AACpB","sourcesContent":["@import url(\"../../components/button/common.css\");\n\nbutton {\n  position: relative;\n\n  display: flex;\n\n  gap: 0.25rem;\n  align-items: center;\n  justify-content: center;\n\n  width: 9rem;\n  height: 2rem;\n\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n\n  font: var(--type-emphasis-m);\n}\n\n.progress {\n  display: block;\n\n  width: 0.8rem;\n  height: 0.8rem;\n\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
